import { getYearRange, requireValidation } from "utils/helpers";
const alias = (() => {
  try {
    const stored = localStorage.getItem("oze-loans");
    return stored ? JSON.parse(stored)?.state?.customization?.alias || "" : "";
  } catch {
    return "";
  }
})();

export const personalFields1 = (t: any) => [
  {
    title: "whatIsFullName",
    type: "input",
    inputType: "text",
    placeholder: "enterFullName",
    name: "fullName",
    validation: {
      required: requireValidation,
      validate: (value) => {
        const fullNameParts = value.trim().split(" ");
        return (
          (fullNameParts.length >= 2 && fullNameParts.every((part) => part.length > 0)) ||
          t("fullNameValidationError")
        );
      },
    },
    disabled: false,
    required: true,
  },
  {
    title: "whatIsEmailAddress",
    type: "input",
    inputType: "email",
    placeholder: "enterEmailAddress",
    name: "email",
    disabled: false,
    required: true,
    validation: {
      required: requireValidation,
      validate: (value) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return (
          emailRegex.test(value) ||
          t("pleaseEnterValidEmailAddress")
        );
      },
    },
  },
  {
    title: "dateOfBirth",
    type: "input",
    inputType: "date",
    placeholder: "",
    name: "dateOfBirth",
    validation: {
      required: requireValidation,
      validate: (value) => {
        const selectedDate = new Date(value);
        const today = new Date();

        if (selectedDate > today) {
          return t("invalidDateOfBirthFuture");
        }

        const age = today.getFullYear() - selectedDate.getFullYear();

        if (age < 21 || age > 70) {
          return t("invalidDateOfBirthRange");
        }

        return true;
      },
    },
    required: true,
  },
];

export const personalFields2 = [
  {
    title: "whatIsMaritalStatus",
    type: "select",
    inputType: "text",
    placeholder: "enterMaritalStatus",
    options: ["single", "married", "engaged", "divorced", "widowed", "notAvailable"],
    name: "maritalStatus",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
  {
    title: "whatIsYourGender",
    type: "select",
    inputType: "text",
    placeholder: "selectGender",
    options: ["male", "female", "preferNotToSay"],
    name: "gender",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
  {
    title: "whatHighestLevelOfEducation",
    type: "select",
    inputType: "text",
    options: ["Primary", "Secondary", "Tertiary", "Masters", "PhD"],
    name: "levelOfEducation",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
];

export const housingFields = (t: any) => [
  {
    title: "whatYourResAddress",
    type: "input",
    inputType: "text",
    placeholder: "enterYourResAddress",
    name: "address",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
  {
    title: "howManyCellPhones",
    type: "select",
    inputType: "text",
    placeholder: "",
    options: [
      { key: 1, value: 1 },
      { key: 2, value: 2 },
      { key: 3, value: 3 },
      { key: 4, value: 4 },
      { key: 5, value: 5 },
    ],
    name: "numOfCellPhonesOwned",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
  {
    title: "howManyChildren",
    type: "input",
    inputType: "number",
    placeholder: "enterNumberChildren",
    name: "numOfChildren",
    validation: {
      required: requireValidation,
      minLength: {
        value: 0,
        message: t("enterValidNumber"),
      },
    },
    required: true,
  },
];

export const additionalFields = [
  {
    title: "doYouUseWhatsappBizOrPersonal",
    type: "select",
    inputType: "text",
    placeholder: "chooseOne",
    options: [
      { key: "PERSONAL", value: "Personal" },
      { key: "BUSINESS", value: "Business" },
      { key: "PERSONALANDBUSINESS", value: "PersonalAndBusiness" },
    ],
    name: "whatsappType",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
  {
    title: "howManyPeopleTurnToSupport",
    type: "input",
    inputType: "number",
    placeholder: "",
    name: "numFinancialSupport",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
];

export const nextOfKinFields = [
  {
    title: "nameOfNextKin",
    type: "input",
    inputType: "text",
    placeholder: "",
    name: "nextOfKinName",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
];

export const businessDetailsField1 = [
  {
    title: "whatisBusinessName",
    type: "input",
    inputType: "text",
    placeholder: "enterBusinessName",
    name: "businessName",
    disabled: false,
    required: true,
    validation: {
      required: requireValidation,
    },
  },
  {
    title: "whatYourBusinessDo",
    type: "input",
    inputType: "text",
    placeholder: "enterBusinessDescription",
    name: "businessDescription",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
  {
    title: "whatBusinessAddress",
    type: "input",
    inputType: "text",
    placeholder: "enterBusinessAddress",
    name: "businessAddress",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
];

export const businessDetailsField2 = [
  {
    title: "whatYearBusinessStart",
    type: "select",
    inputType: "text",
    placeholder: "chooseOne",
    options: getYearRange(1980),
    name: "yearBusinessStarted",
    validation: {
      required: requireValidation,
      validate: (value: any) => value && value !== "" || "required"
    },
    required: true,
  },
  {
    title: "howManyEmployeesEmployed",
    type: "input",
    inputType: "text",
    placeholder: "enterNumberOfEmployees",
    name: "numberOfEmployees",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
];

export const businessRegField = [
  {
    title: "whatIsCacNum",
    type: "input",
    inputType: "text",
    placeholder: "enterCacNum",
    name: "cacNumber",
    validation: alias === "zojapay" ? {} : { required: requireValidation },
    required: alias === "zojapay" ? false : true,
  },
];

export const tinAndAdditionalFields = [
  {
    title: "whatIsYourTin",
    type: "input",
    inputType: "text",
    placeholder: "enterYourTin",
    subText: "tinExample",
    name: "tinNumber",
    validation: {},
    required: false,
  },
  {
    title: "whatKindOfTin",
    type: "select",
    inputType: "text",
    placeholder: "",
    options: [
      {
        key: "NONE",
        value: "None",
      },
      {
        key: "PERSONAL",
        value: "Personal",
      },
      {
        key: "BUSINESS",
        value: "Business",
      },
    ],
    name: "tinType",
    validation: {},
    required: false,
  },
  {
    title: "whichTradeAssociations",
    type: "input",
    inputType: "text",
    placeholder: "",
    subText: "leaveBlankIfNotMember",
    name: "tradeAssociation",
    required: false,
  },
  {
    title: "whenWereYouLastWithoutIncome",
    type: "input",
    inputType: "date",
    placeholder: "chooseDate",
    name: "periodWithNoIncome",
    required: false,
  },
];

export const financialDetailsField = [
  {
    title: "whatIsCurrentBankBalance",
    type: "group",
    inputType: "currency",
    placeholder: "enterBankBalance",
    name: "currentBankBalance",
    required: true,
    validation: {
      required: requireValidation,
    },
  },
  {
    title: "whatIsCurrentMobileMoneyBal",
    type: "group",
    inputType: "currency",
    placeholder: "enterMobileMoneyBal",
    name: "currentMomoBalance",
    required: alias === "zojapay" ? false : true,
    validation: alias === "zojapay" ? {} : { required: requireValidation },
  },
];

export const loanDetailsField = [
  {
    title: "howMuchDoYouNeedBorrow",
    type: "group",
    inputType: "currency",
    placeholder: "enterAmount",
    // subText: "Loans may carry 5% interest monthly",
    name: "amount",
    validation: {
      required: requireValidation,
    },
    required: true,
  },
];

export const bankInfoFields = [
  {
    title: "whatIsBVN",
    type: "input",
    inputType: "number",
    placeholder: "enterBVN",
    name: "bankVerificationNumber",
    validation: {
      required: requireValidation,
      maxLength: {
        value: 11,
        message: "charactersMax",
      },
      minLength: {
        value: 11,
        message: "charactersMin",
      },
    },
    required: true,
  },
];

// End Financial Information
